import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';

import {
  MsalGuardConfig,
  MsalInstanceConfig,
  MsalInterceptorConfig,
  ProtectedResource,
} from './models';

export const loggerCallback = (
  logLevel: LogLevel,
  message: string,
  containsPii: boolean
) => {
  if (containsPii) {
    return;
  }
  switch (logLevel) {
    case LogLevel.Error: {
      console.error(message);
      break;
    }
    case LogLevel.Info: {
      // eslint-disable-next-line no-console
      console.info(message);
      break;
    }
    case LogLevel.Verbose: {
      // eslint-disable-next-line no-console
      console.debug(message);
      break;
    }
    case LogLevel.Warning: {
      console.warn(message);
      break;
    }
    default: {
      // eslint-disable-next-line no-console
      console.log(message);
    }
  }
};

export const getMsalInstanceConfig = (
  msalInstanceConfig: MsalInstanceConfig
): IPublicClientApplication =>
  new PublicClientApplication({
    auth: {
      clientId: msalInstanceConfig.clientId,
      authority: `${msalInstanceConfig.loginUrl}${msalInstanceConfig.tenantId}/`,
      redirectUri: msalInstanceConfig.redirectUri,
      postLogoutRedirectUri: msalInstanceConfig.postLogoutRedirectUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
    system: {
      allowRedirectInIframe: msalInstanceConfig.allowRedirectInIframe,
      loggerOptions: {
        loggerCallback: msalInstanceConfig.loggingEnabled
          ? loggerCallback
          : undefined,
        piiLoggingEnabled: false, // do not log personal information
      },
    },
  });

export const getMsalInterceptorConfig = (
  msalInterceptorConfig: MsalInterceptorConfig
): MsalInterceptorConfiguration => {
  const protectedResourceMap = new Map<string, string[]>([
    ['https://graph.microsoft.com/v1.0/me', ['user.read']],
    ['https://graph.microsoft.com/v1.0/me/photos/64x64/$value', ['user.read']],
  ]);

  msalInterceptorConfig.protectedResources.forEach(
    (protectedResource: ProtectedResource) => {
      protectedResourceMap.set(
        protectedResource.route,
        protectedResource.scopes
      );
    }
  );

  return {
    protectedResourceMap,
    interactionType: msalInterceptorConfig.interactionType,
  };
};

export const getMsalGuardConfig = (
  msalGuardConfig: MsalGuardConfig
): MsalGuardConfiguration => ({
  interactionType: msalGuardConfig.interactionType,
  loginFailedRoute: msalGuardConfig.loginFailedRoute,
  authRequest: {
    scopes: msalGuardConfig.scopes,
  },
});
